import Swal, { type SweetAlertOptions } from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

/** Classes padrão dos botões de ação nos modais (vermelho do projeto) */
export const SWAL_BRAND_CUSTOM_CLASS = {
  confirmButton: "btn btn-primary",
  denyButton: "btn btn-outline-primary ms-1",
  cancelButton: "btn btn-outline-primary ms-1",
} as const;

type SwalCustomClassMap = Record<string, string>;

function resolveCustomClass(
  customClass: SweetAlertOptions["customClass"]
): SwalCustomClassMap {
  if (customClass && typeof customClass === "object") {
    return customClass as SwalCustomClassMap;
  }
  return {};
}

/** Mescla opções do Swal com o tema visual padrão do projeto */
export function mergeSwalTheme(
  options: SweetAlertOptions
): SweetAlertOptions {
  const { customClass: userCustomClass, ...rest } = options;

  return {
    buttonsStyling: false,
    ...rest,
    customClass: {
      ...SWAL_BRAND_CUSTOM_CLASS,
      ...resolveCustomClass(userCustomClass),
    },
  };
}

const ThemedSwal = Swal.mixin({
  buttonsStyling: false,
  customClass: SWAL_BRAND_CUSTOM_CLASS,
});

/** Instância SweetAlert2 com tema do projeto (suporta JSX via react-content) */
export const MySwal = withReactContent(ThemedSwal);

/** Fire com tema aplicado automaticamente */
export function fireThemedAlert(options: SweetAlertOptions) {
  return MySwal.fire(mergeSwalTheme(options));
}
